import { PersonalIdentifierDocumentDto } from '../../models';

export const validatePid = (item: PersonalIdentifierDocumentDto) => {
  const fields: (keyof PersonalIdentifierDocumentDto)[] = [];

  if (item.name !== undefined && typeof item.name !== 'string') fields.push('name');
  if (item.country !== undefined && typeof item.country !== 'string') fields.push('country');

  return { valid: fields.length === 0, fields };
};
